export const leadChipStatusColor = {
  Active: "var(--lightBlue)",
  Idle: "var(--chipYellow)",
  Awarded: "var(--chipPink)",
  Rejected: "var(--chipRed)",
  Close : "var(--chipRed)"
};
